import {
  ContainerChargeDto,
  DeclarationChargeDto,
  DeviationDto,
  PercentageChargeDto,
  ShipmentChargeDto,
  WeightChargeDto,
} from 'src/generated/services/TFinancialApi';
import { TableRateCardContainer } from './TableRateCardContainer';
import { TableRateCardShipment } from './TableRateCardShipment';
import { TableRateCardWeight } from './TableRateCardWeight';
import { TableRateCardPercentage } from './TableRateCardPercentage.tsx';

export interface ITableRateCardChargeProps {
  data: DeviationDto['matchingRateCards'];
  type: DeviationDto['contractChargeUnit'];
}

export const TableRateCardCharge = ({ data, type }: ITableRateCardChargeProps) => {
  if (type === 'CONTAINER') {
    return <TableRateCardContainer data={data as ContainerChargeDto[]} />;
  }

  if (type === 'DECLARATION' || type === 'SHIPMENT') {
    // Both DECLARATION and SHIPMENT use the same table component
    return <TableRateCardShipment data={data as (ShipmentChargeDto | DeclarationChargeDto)[]} />;
  }

  if (type === 'WEIGHT') {
    return <TableRateCardWeight data={data as WeightChargeDto[]} />;
  }

  if (type === 'PERCENTAGE') {
    return <TableRateCardPercentage data={data as PercentageChargeDto[]} />;
  }

  return null;
};
